<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <v-alert v-if="error" tile type="error">{{ error }}</v-alert>
                <v-card-title>{{ formTitle }}</v-card-title>
                <v-card-text>
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="editedItem.name"
                                    :counter="50"
                                    :rules="[rules.required]"
                                    label="Name*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="editedItem.width"
                                    :rules="[rules.required]"
                                    type="number"
                                    suffix="m"
                                    label="Width*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="editedItem.height"
                                    :rules="[rules.required]"
                                    type="number"
                                    suffix="m"
                                    label="Height*"
                                    outlined
                                    class="subtitle-2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-5 pr-5">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="close">Cancel</v-btn>
                    <v-btn outlined rounded :loading="isSaving" color="primary" @click="save">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import helper from "@/utils/helper.js";
import Config from "@/utils/config.json";

export default {
    name: "greenhouse-edit-dialog",
    props: ["dialog", "object"],
    data() {
        return {
            error: null,
            isSaving: false,
            editedItem: {
                id: "",
                name: "",
                width: null,
                height: null
            },
            defaultItem: {
                id: "",
                name: "",
                width: null,
                height: null
            },
            rules: {
                required: v => !helper.isEmpty(v) || "This field is required",
                minLength: len => v =>
                    (v || "").length >= len ||
                    `Invalid character length, required ${len}`,
                maxLength: len => v => (v || "").length <= len || "Too long"
            }
        };
    },
    computed: {
        formTitle() {
            return this.object ? "Edit Greenhouse" : "New Greenhouse";
        },
        meterToPixelRatio() {
            return Config.meterToPixelRatio;
        }
    },
    watch: {
        // reset form when dialog open or close
        dialog() {
            this.resetForm();
        }
    },
    methods: {
        resetForm() {
            // reset form state
            this.error = null;
            this.isSaving = false;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }

            // when editing, set form with object
            if (this.dialog && this.object) {
                this.editedItem.id = this.object.id;
                this.editedItem.name = this.object.name;
                this.editedItem.width =
                    this.object.width / Config.meterToPixelRatio;
                this.editedItem.height =
                    this.object.height / Config.meterToPixelRatio;
            }
            // when new or closing, set form with default
            else {
                this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
                this.$emit("update:object", null);
            }
        },

        close() {
            this.$emit("update:dialog", false);
            this.resetForm();
        },

        save() {
            if (!this.$refs.form.validate()) {
                return;
            }

            // set form state
            this.error = null;
            this.isSaving = true;

            // prepare api call payload
            var payload = {
                name: this.editedItem.name,
                width: this.editedItem.width * this.meterToPixelRatio,
                height: this.editedItem.height * this.meterToPixelRatio
            };

            // edit
            if (this.object) {
                // prepare graphql mutation payload
                payload.id = this.editedItem.id;

                // update
                this.$store
                    .dispatch("greenhouses/updateGreenhouse", payload)
                    .then(response => {
                        // update parent object
                        this.$emit("update:object", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors[0].message;
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
            // new
            else {
                this.$store
                    .dispatch("greenhouses/createGreenhouse", payload)
                    .then(response => {
                        this.$emit("item-created", response);
                        this.close();
                    })
                    .catch(error => {
                        this.error = error.graphQLErrors
                            .map(error => error.message)
                            .join(", ");
                        this.isSaving = false;
                    })
                    .finally(() => {});
            }
        }
    }
};
</script>